import { constants, useWindowSize } from "@newsela/angelou";

const {
  breakpoints: { Breakpoints },
} = constants;

const SM = "sm";
const MD = "md";
const LG = "lg";

export const landscapeThresold = 0;
export const crownRowLargeThreshold = 0.3;
export const crownRowThreshold = 0.1;

export const thresholdMap = {
  sm: 0.2,
  md: 0.5,
  lg: 1.0,
};

function getScreensize(windowSize) {
  if (windowSize.width > Breakpoints.sm && windowSize.width < Breakpoints.md) {
    return MD;
  } else if (windowSize.width >= Breakpoints.md) {
    return LG;
  } else {
    return SM;
  }
}

function useThresholdOptions() {
  const windowSize = useWindowSize();
  const screenSize = getScreensize(windowSize);
  const isLandscapeView = windowSize.width > windowSize.height;
  const minCardHeight = 460;

  // The important measurement for the tracker is the height of the screen.
  // If there's no height for a card, any portion of this row should trigger
  // intersection observer.
  if (isLandscapeView && windowSize.height < minCardHeight) {
    return landscapeThresold;
  }
  return thresholdMap[screenSize];
}

export default useThresholdOptions;
